import type { ReactElement } from "react"
import { Link } from "@tanstack/react-router"

import { FloorPilotLogo } from "@/components/brand"
import { Button } from "@/components/ui/button"

/** Branded 404 for unknown URLs (router `defaultNotFoundComponent`). Signed-out visitors clicking
 * through to the dashboard bounce cleanly via `requireAuth` → sign-in. */
export function NotFoundScreen(): ReactElement {
	return (
		<div className="bg-background flex min-h-svh flex-col items-center justify-center gap-4 px-6 py-16">
			<FloorPilotLogo variant="navbar-wordmark" className="block h-7 w-auto" />
			<p className="text-foreground text-center text-base font-medium">We couldn't find that page.</p>
			<p className="text-muted-foreground max-w-md text-center text-sm">
				The link may be outdated, or the page may have moved.
			</p>
			<Button asChild>
				<Link to="/dashboard">Go to Dashboard</Link>
			</Button>
		</div>
	)
}
